import { Fragment } from "react/jsx-runtime";
import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";

type HandlePopupCloseType = (confirmLeave: boolean) => void;

interface IDGDiscontinuationPopupProps {
  handlePopupClose: HandlePopupCloseType;
}

export default function IDGDiscontinuationPopup({
  handlePopupClose,
}: IDGDiscontinuationPopupProps) {
  return (
    <Fragment>
      <span>
        <CustomText
          text="Effective May 2, 2025 the IDgenetix test will be removed from our portfolio of test offerings."
          fontWeight="font-normal"
        // className="text-red-500"
        />
        <a href="https://cbslocal01.blob.core.windows.net/help-section/IDgenetix_Notice.pdf" className="text-[#0B4D89] font-semibold" target="_blank">
          Click here for more information
        </a>
      </span>
      <div className="flex items-end  justify-end mt-3">
        {/* <Button
          textInformation={{ text: "Cancel", fontWeight: "font-semibold" }}
          onClick={() => handlePopupClose(false)}
          buttonTheme="secondary"
          className="mr-3"
        /> */}
        <Button
          textInformation={{ text: "Continue", fontWeight: "font-semibold" }}
          onClick={() => handlePopupClose(true)}
          buttonTheme="primary"
        />
      </div>
    </Fragment>
  );
}
